import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateInput } from '../../types/date-input';
import { QueryParams } from '../../types/query-params';
import { FEEDER_TYPES } from '../../types/menu';

/* global require */

@Component({
  selector: 'feeder-query-period',
  template: require('./query-period.component.html'),
})
export class QueryPeriodComponent implements OnInit, OnChanges {
  query_all: boolean = false;
  date = new Date();

  @Input() quStart: DateInput = {
    year: new Date().getFullYear() - 1,
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  };
  @Input() quEnd: DateInput = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  };
  @Output() quStartChange = new EventEmitter();
  @Output() quEndChange = new EventEmitter();

  formControlLatestPrice = new FormControl(false);
  formControlQueryAll = new FormControl(false);

  isAuction: boolean = false;
  isFundamental: boolean = false;
  isForwardCurve: boolean = false;
  @Input() type!: string;
  @Input() queryParams: QueryParams = new QueryParams();
  @Output() queryParamsChange = new EventEmitter<QueryParams>();
  @Output() queryAll = new EventEmitter<boolean>();

  constructor() {
    this.initFields();
  }

  initFields() {
    this.isFundamental = this.type === FEEDER_TYPES.FUNDAMENTAL_DATA;
    this.isForwardCurve = this.type === FEEDER_TYPES.FORWARD_CURVE;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initFields();
  }

  ngOnInit(): void {
    this.formControlLatestPrice.valueChanges.subscribe((val) => {
      if (val !== null) {
        this.queryParams.latest_price = val;
        this.queryParamsChange.emit(
          JSON.parse(JSON.stringify(this.queryParams))
        );
      }
    });
    this.formControlQueryAll.valueChanges.subscribe((val) => {
      if (val !== null) {
        this.query_all = val;
        this.queryAll.emit(this.query_all);
      }
    });
  }
}
